import React from 'react';
import CustomButton from 'components/CustomButtons/Button';
import CanPerform from 'components/CanPerform/CanPerform';
import { translate } from 'components/Translation';
import { Caption } from 'components/Typography/Typography';

interface IResendEmailProps {
	enabled: boolean;
	onClick: (event: any) => void;
	lastSentActivationEmailDate: string;
	userType: string;
}

const ResendEmail = ({ enabled, onClick, lastSentActivationEmailDate, userType = 'MANAGER' }: IResendEmailProps) => {
	const action = `user-details:resend-${userType.toLowerCase()}-activation-email`;
	return (
		<CanPerform
			action={action}
			yes={
				enabled ? (
					<div>
						<CustomButton color="primary-light" onClick={onClick}>
							{translate('manager.resend.activation.email')}
						</CustomButton>
						{lastSentActivationEmailDate && (
							<Caption color="secondary-light">
								{translate('user.details.email.sent.date', lastSentActivationEmailDate)}
							</Caption>
						)}
					</div>
				) : null
			}
		/>
	);
};

export default ResendEmail;
